import React, { Component } from "react";
import Ejercicios from "./ejercicios/ejercicios";
import Rutinas from "./rutinas/rutinas";
import Modelos from "./modelos/modelos";
import Personal from "./personal/myplan";
import * as moment from "moment";
import "./content.css";
import { connect } from "react-redux";
import * as exerciseService from "../../services/exercise";
import { Container } from "react-bootstrap";
import FooterInfo from "../footer/footerInfo";
import Header from "../header/header";
import Footer from "../footer/footer";

class Content extends Component {
	constructor(props) {
		super(props);
		this.state = {
			width: 768,
			isLogged: false,
		};
		this.handleClick = this.handleClick.bind(this);
		this.setPlanLocalstorage = this.setPlanLocalstorage.bind(this);
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

		exerciseService.getToken().then((res) => {
			this.setState({ isLogged: true });
			//document.getElementById("loading").style.display = "none";
		});
	}
	handleClick() {
		this.props.firstPageRef.current.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});
	}
	componentDidMount() {
		this.setPlanLocalstorage();
		window.addEventListener("resize", this.updateWindowDimensions());
	}
	updateWindowDimensions() {
		this.setState({ width: window.innerWidth });
	}
	setPlanLocalstorage() {
		var dateEnd = localStorage.getItem("endplan");
		if (dateEnd) {
			var date = moment(dateEnd);
			if (moment().isAfter(date)) {
				localStorage.clear();
				localStorage.setItem("endplan", moment().add(30, "days").format());
			} else {
				let plan = JSON.parse(localStorage.getItem("plan"));
				if (plan) {
					this.props.setPersonalPlan(plan);
				}
				localStorage.setItem("endplan", moment().add(30, "days").format());
			}
		} else {
			localStorage.setItem("endplan", moment().add(30, "days").format());
		}
	}
	render() {
		return (
			<>
				<Header />
				{this.props.isSearch ? <Personal /> : null}
				<div ref={this.props.muscleRef}>
					<div className='loading' id='loading' style={{ display: "none" }}>
						<div className='uil-ring-css' style={{ transform: "scale(0.79)" }}>
							<div></div>
							<p className='loader-text'>Cargando los mejores ejercicios</p>
						</div>
					</div>
					<div className={"titlePage"}>
						<div className={"container"}>
							{this.state.width > 767 ? (
								<h1 className='title'>GUÍA DE EJERCICIOS</h1>
							) : (
								<h4
									className='title'
									style={{ marginBottom: "10px", fontSize: "48px" }}
								>
									GUÍA DE EJERCICIOS
								</h4>
							)}
							<p>
								Diseña tu propia rutina de entrenamiento con una base de datos
								de más de 1,800 ejercicios con vídeos detallados de cada uno y
								encuentra cualquier ejercicio que necesitas buscando por el tipo
								de ejercicio, grupo muscular, nombre o implemento a usar.
							</p>
						</div>
					</div>

					<div className='container' style={{ paddingBottom: "20px" }}>
						{!this.props.isSearch ? <Modelos /> : null}
						{/* <hr /> */}
					</div>
				</div>
				<Container fluid='md'>
					{this.props.isSearch && this.state.isLogged ? <Ejercicios /> : null}
				</Container>
				<div
					className='container'
					style={{ paddingBottom: "40px", display: "flex" }}
				>
					{/* <Button style={{ margin: "0 auto" }} onClick={this.handleClick}>
            Quiero una rutina personalizada
          </Button> */}
				</div>
				<div className='container'>
					{this.props.isSearch ? <Rutinas /> : null}
				</div>
				<div className='container'>
					{this.props.isSearch ? <FooterInfo /> : null}
				</div>
				<div ref={this.props.firstPageRef}>{/* <FirstPage /> */}</div>

				<Footer />
			</>
		);
	}
}
const mapStateToProps = (state) => ({
	muscleRef: state.muscleRef,
	firstPageRef: state.firstPageRef,
	personalPlan: state.personalPlan,
	musculo: state.musculo,
	ejercicios: state.ejercicios,
	isSearch: state.isSearch,
});
const mapDispatchToProps = (dispatch) => ({
	setPersonalPlan(plan) {
		dispatch({
			type: "SET_PLAN",
			plan: plan,
		});
	},
	selectMusculo(musculo) {
		document.getElementById("loading").style.display = "block";
		exerciseService
			.getExercises(
				`exercisename=null&bodypart=null&musclegroup=${musculo}&apparatus=null&difficulty=null&utility_name=null&movement_name=null&apparatus_groups_name=null&mechanics=null&force=null&synergists=null&stabilizers=null&movement=null&subcategory=null&lang=es`
			)
			.then((res) => {
				var exercise = [];
				document.getElementById("loading").style.display = "none";
				for (const key in res.data.exercises) {
					if (Object.hasOwnProperty.call(res.data.exercises, key)) {
						exercise.push(res.data.exercises[key]);
					}
				}
				dispatch({
					type: "SELECT_MUSCULO",
					musculo,
					apparatus: null,
					scroll: true,
					ejercicios: exercise,
				});
			})
			.catch((err) => {
				console.log(err);
			});
	},
});
export default connect(mapStateToProps, mapDispatchToProps)(Content);
